import { escapeHtml } from "../acrotohtml/escapeHtml";
import type { DocTable } from "./types";
import { renderTableRow } from "./renderTableRow";

export function renderTable(table: DocTable): string {
  const tableId = escapeHtml(table.TableId);
  const tableHeading = table.TableHeading ? escapeHtml(table.TableHeading) : "";

  const rowsHtml = table.TableRows
    .map((row) => renderTableRow(row))
    .join("");

  return `
    <div data-table-id="${tableId}">
      ${tableHeading ? `<h3 class="text-lg font-semibold text-gray-800 mb-3">${tableHeading}</h3>` : ""}
      <div class="w-full border border-gray-300 bg-white rounded-md overflow-hidden" data-table-id="${tableId}">
        ${rowsHtml}
      </div>
    </div>
  `;
}
